export const LIKE_COUNTER_CACHE_KEY = 'like_counter';
